import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CommentsList } from '@widgets/shared/Comments/CommentsList/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { useProgramQuery } from '@src/api/api-hooks/programs/useProgramQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';

type PT = {};
export const ProgramComments = ({}: PT) => {
  const { id } = useParams();
  const { data } = useProgramQuery({ id });
  const { user } = useUser();
  const isContentAuthor = useMemo(() => user?.id === data?.author.id, [data, user]);
  return data ? (
    <CommentsList
      isPaid={data?.is_paid || data?.cost_base === 0}
      isContentAuthor={isContentAuthor}
      comments={data.comments}
      program={Number(id)}
    />
  ) : (
    <Loader />
  );
};
